module.exports = __webpack_public_path__ + "src/img/kuaibian.8ca90962.svg";